import template from './discount.html';
import controller from './discount.controller';

const menuDiscountComponent = {
  binding: 'E',
  controller,
  template
};

export default menuDiscountComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/discount/discount.component.js
 **/